import { IApplicationState } from '@bridebook/web/lib/types';

export const getIsCollaborator = (state: IApplicationState) => {
  const userId = state.users.user?.id;
  const collaborators = state.weddings.collaborators;
  const userInCollaborators = collaborators.find((collaborator) => collaborator.id === userId);

  return userInCollaborators?.primary === false;
};
